/**
 * @desc 搜索 SIPDevice
 */

import * as SWR from 'swr';

import * as defs from '../../baseClass';
import * as Hooks from '../../../hooks';
import { PontCore } from '../../../pontCore';

export class Params {
  /** 会议房间 ID，用于判断是否已经加入会议 */
  channelId?: string;
  /** 用户设备本地 IP，可能是局域网 IP */
  clientLocalIp?: string;
  /** 查询关键字 */
  keyword?: string;
  /** 用户设备所处 IANA 时区 */
  timeZone?: string;
}

export const method = 'GET';

export function mutate(
  params = {},
  newValue = undefined,
  shouldRevalidate = true,
) {
  return SWR.mutate(
    Hooks.getUrlKey(
      '/api/bs-vmeeting/v3/meeting/call/sip-search',
      params,
      'GET',
    ),
    newValue,
    shouldRevalidate,
  );
}

export function useRequest(params = {}, swrOptions = {}) {
  return Hooks.useRequest(
    '/api/bs-vmeeting/v3/meeting/call/sip-search',
    params,
    swrOptions,
  );
}

export function request(params: Params, options?: any) {
  return PontCore.fetch(
    PontCore.getUrl(
      '/api/bs-vmeeting/v3/meeting/call/sip-search',
      params,
      'GET',
    ),
    {
      method: 'GET',

      ...options,
    },
  );
}
